import { OrganizationsStoreActionsClass } from './OrganizationsStoreActionsClass';

const OrganizationsStore: OrganizationsStoreActionsClass = new OrganizationsStoreActionsClass();

export { OrganizationsStore };
